import { useCallback } from "react";
import { useGlobalMessageActions } from "../../../entities/globalMessage";
import { useMyActions } from "../../../entities/my";
import { AuthError } from "../../../shared/lib/error/AuthError";
import { MyError } from "../../../shared/lib/error/MyError";

export const useStaffFeedback = () => {
    const {setIsAuth} = useMyActions()
    const {setGlobalMessage} = useGlobalMessageActions()

    const handleError = useCallback((error: unknown, defaultMessage: string) => {
        console.log(error)

        if(error instanceof AuthError){
            setIsAuth(false)
            setGlobalMessage({message: error.message, type: 'error'})
            return
        }

        if(error instanceof MyError){
            setGlobalMessage({message: error.message, type: 'error'})
            return
        }

        setGlobalMessage({message: defaultMessage, type: 'error'})
    }, [setGlobalMessage, setIsAuth])

    const showSuccess = useCallback((message: string) => {
        setGlobalMessage({message, type: 'ok'})
    }, [setGlobalMessage])

    const showError = useCallback((message: string) => {
        setGlobalMessage({message, type: 'error'})
    }, [setGlobalMessage])

    return {handleError, showError, showSuccess}
}
